import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import CursorIcon from './CursorIcon';
import NameTag from './NameTag';
/**
 * Cursor is a type of **molecule** that represent user by a cursor icon and a rectangular name tag.
 */
const Cursor = ({ className, cursorColor, firstName, lastName, ...rest }) => {
    const dataAttributes = useDataAttributes(rest);
    return (_jsxs("span", { className: buildClassName('relative', className), ...dataAttributes, children: [_jsx(CursorIcon, { className: buildClassName('absolute left-0 top-0', {
                    'text-real-time-collaboration-blue': cursorColor === 'blue',
                    'text-real-time-collaboration-red': cursorColor === 'red',
                    'text-real-time-collaboration-purple': cursorColor === 'purple',
                    'text-real-time-collaboration-green': cursorColor === 'green',
                }) }), _jsx(NameTag, { className: `absolute bg-real-time-collaboration-${cursorColor} left-5 top-5 whitespace-nowrap`, firstName: firstName, lastName: lastName })] }));
};
export default Cursor;
//# sourceMappingURL=Cursor.js.map